import { useAnalyticsView } from '@melio/platform-analytics';

import { NewSinglePaymentStepLayout } from '../../NewSinglePaymentStepLayout';

export const InitialStep = () => {
  useAnalyticsView('access-to-accounting-software');

  return <NewSinglePaymentStepLayout isLoading />;
};
